import type { Box } from './strangler'

// Environment flag (pristine: script.js:35 `window.isDevVersion =
// location.href.indexOf('demonin.com') == -1`). Engine-relevant readers:
// the second autosave gate (index.html bootstrap) and updateLarge's
// production-only branch (script.js:2349). The bridge seeds from the value
// the pristine line already computed, so semantics are byte-identical; this
// module becomes the injected config port at extraction time.
export const isDevVersion: Box<boolean> = { value: true }
